var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m655.673691 718.395887 48.894982-18.843408c1.202336-222.913515 35.268512-444.624259 100.996192-657.5146843 6.412457-11.2258604 3.607007-25.258186-6.412456-33.27665776-8.015571-8.41939534-20.840484-11.22586045-31.661505-6.4147774-212.813405 64.14777406-433.241602 99.42904946-655.673691 104.24013246l-20.4397059 48.912678c166.7238729 22.050797 335.8524169 22.050797 502.9770679 0l-594.354575 594.569681 56.9105527 56.931149 594.3545753-594.569681c-24.046713 167.986984-22.443599 338.379508 4.408563 505.965568z","fill":"#fff"}));
}

Arrow.defaultProps = {"height":"807","viewBox":"0 0 809 807","width":"809"};

module.exports = Arrow;

Arrow.default = Arrow;
